import { AbstractControl } from "@angular/forms";

const pendingInvalidCharacterByControl = new WeakMap<AbstractControl, boolean>();

export function markPendingCnpjInvalidCharacter(control: AbstractControl): void {
  pendingInvalidCharacterByControl.set(control, true);
}

export function hasPendingCnpjInvalidCharacter(
  control: AbstractControl
): boolean {
  return pendingInvalidCharacterByControl.get(control) === true;
}

export function consumePendingCnpjInvalidCharacter(
  control: AbstractControl
): boolean {
  if (!hasPendingCnpjInvalidCharacter(control)) {
    return false;
  }

  pendingInvalidCharacterByControl.delete(control);
  return true;
}

export function clearPendingCnpjInvalidCharacter(
  control: AbstractControl
): void {
  pendingInvalidCharacterByControl.delete(control);
}
